import {cva, type VariantProps} from 'class-variance-authority'

export {default as Avatar} from './Avatar.vue'
export {default as AvatarImage} from './AvatarImage.vue'
export {default as AvatarFallback} from './AvatarFallback.vue'
export {default as FloatingAvatars} from './FloatingAvatars.vue'

export const avatarVariant = cva(
    'inline-flex items-center justify-center font-normal text-foreground select-none shrink-0 bg-secondary overflow-hidden active:scale-[0.9] cursor-pointer transition-transform',
    {
        variants: {
            size: {
                xs: 'h-8 w-8 text-xs',
                sm: 'h-9 w-9 text-xs',
                smd: 'h-11 w-11 text-sm',
                md: 'h-14 w-14 text-lg',
                base: 'h-16 w-16 text-2xl',
                lg: 'h-16 w-16 md:h-20 md:w-20 text-3xl',
                xl: 'w-64 h-64  text-7xl',
                xxl: 'w-64 h-64 md:w-80 md:h-80  text-7xl',
            },
            shape: {
                circle: 'rounded-full',
                square: 'rounded-md',
            },
        },
    },
)

export type AvatarVariants = VariantProps<typeof avatarVariant>
